import { JSX } from 'react';
import classNames from 'classnames';
import { HomeIcon } from '@bg-components/Icon';
import { iframeIntegration, useRipple, WebIntegrationType, partnerSettingsStore } from '@bg-shared';
import classes from './HomeButton.module.scss';

interface IProps {
    homeUrl: string;
}

export const HomeButton = (props: IProps): JSX.Element => {
    const ripple = useRipple();
    const onClick = (): void => {
        iframeIntegration.homeButtonClick(props.homeUrl);
    };

    return (
        <a
            data-qa="link-top-navigation-home"
            className={classNames(classes.link, ripple.className, {
                [classes.showOnDesktop]:
                    partnerSettingsStore.webIntegrationType === WebIntegrationType.FEIM,
            })}
            target={_featuresConfig.homeButtonTarget || '_top'}
            href={_featuresConfig.homeButtonNoRedirect ? undefined : props.homeUrl}
            onClick={_featuresConfig.homeButtonNoRedirect ? onClick : undefined}
            onMouseDown={ripple.start}
        >
            <HomeIcon className={classes.icon} />
        </a>
    );
};
